.gs{z-index:2;}